export default __webpack_public_path__ + "static/media/three-lines.ad51e27e.svg";